// Formatting helpers
export const formatValue = (value, type) => {
    if (value === null || value === undefined) return '';
    switch (type) {
        case 'currency':
            if (typeof value === 'number' && !isNaN(value)) {
                return new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(value);
            }
            return String(value);
        case 'number':
            if (typeof value === 'number' && !isNaN(value)) {
                return new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(value);
            }
            return String(value);
        case 'percentage':
        case 'percent':
            if (typeof value === 'number' && !isNaN(value)) {
                return `${(value * 100).toFixed(1)}%`;
            }
            if (!isNaN(Number(value))) {
                const numValue = Number(value);
                return `${(numValue * 100).toFixed(1)}%`;
            }
            return String(value);
        case 'string':
        default:
            return String(value);
    }
};

export const isNumericType = (type) => ['currency', 'number', 'percent', 'percentage'].includes(type);

export const isRightAligned = (type) => !['string', 'text'].includes(type || '');

export const formatDisplay = (value, type) => {
    if (value === null || value === undefined) return '';
    if (['currency', 'number'].includes(type)) {
        const num = Number(value);
        if (!isNaN(num) && num < 0) {
            const absFormatted = formatValue(Math.abs(num), type);
            return `(${absFormatted})`;
        }
    }
    return formatValue(value, type);
};

export const getCellClass = (type, value, opts = {}) => {
    const classes = [];
    if (isNumericType(type)) {
        classes.push('cell-number');
        const num = Number(value);
        if (!isNaN(num) && num < 0) classes.push('negative');
    } else {
        classes.push('cell-text');
    }
    if (opts.subtotal) classes.push('subtotal-cell');
    if (opts.total) classes.push('total-cell');
    return classes.join(' ');
};

export const computeTotalsRow = (columns, rows, totalColumnsSet) => {
    return columns.map((col, colIdx) => {
        if (colIdx === 0) return 'Total';
        const eligible = totalColumnsSet.size === 0 || totalColumnsSet.has(col.selector);
        if (eligible && isNumericType(col.type)) {
            const sum = rows.reduce((acc, row) => {
                const v = Number(row[colIdx]);
                return acc + (isNaN(v) ? 0 : v);
            }, 0);
            return sum;
        }
        return '';
    });
};

export const computeGroupTotals = (rows, columns, totalColumnsSet, calcs) => {
    const opBySelector = Array.isArray(calcs)
        ? calcs.reduce((m, c) => { if (c && c.column && c.op) m.set(c.column, String(c.op).toLowerCase()); return m; }, new Map())
        : null;
    return columns.map((col, colIdx) => {
        if (colIdx === 0) return 'Subtotal';
        const selector = col.selector;
        const type = col.type;
        if (opBySelector && opBySelector.has(selector)) {
            const op = opBySelector.get(selector);
            const values = rows.map(r => Number(r[colIdx])).filter(v => !isNaN(v));
            if (values.length === 0) return '';
            if (op === 'sum') return values.reduce((a, b) => a + b, 0);
            if (op === 'avg' || op === 'average' || op === 'mean') return values.reduce((a, b) => a + b, 0) / values.length;
            if (op === 'min') return Math.min(...values);
            if (op === 'max') return Math.max(...values);
            if (op === 'count') return rows.length;
            const eligible = totalColumnsSet.size === 0 || totalColumnsSet.has(selector);
            if (eligible && isNumericType(type)) {
                const sum = values.reduce((a, b) => a + b, 0);
                return sum;
            }
            return '';
        }
        const eligible = totalColumnsSet.size === 0 || totalColumnsSet.has(selector);
        if (eligible && isNumericType(type)) {
            const sum = rows.reduce((acc, row) => {
                const v = Number(row[colIdx]);
                return acc + (isNaN(v) ? 0 : v);
            }, 0);
            return sum;
        }
        return '';
    });
};


